import { DatePipe } from '@angular/common';
import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DatePickerDialogComponent } from 'src/app/components/date-picker-dialog/date-picker-dialog.component';
import { AvalableDateLabels, DatePickerModel } from 'src/app/components/date-picker-dialog/date-picker.model';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { GetSummaryPayload } from 'src/app/models/dashboard.model';
import { PriceyardService } from 'src/app/modules/priceyard/services/priceyard.service';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-buy-box-graph-details',
  templateUrl: './buy-box-graph-details.component.html',
  styleUrls: ['./buy-box-graph-details.component.scss']
})
export class BuyBoxGraphDetailsComponent implements OnInit, OnDestroy {
  activeTab: string = 'BuyBox Winning';
  private destroy$ = new Subject<void>();
  buyBoxWinningData: any;
  buyBoxWinningChartColors: any[] = ['#3B6EFF']
  buyBoxWinninglabels: any[];
  salesData: any;
  salesChartColors: any[] = ['#FFA600']
  saleslabels: any[];
  competitionData: any;
  competitionChartColors: any[] = ['#31D093']
  competitionlabels: any[];
  repriceActivityData: any;
  repriceActivityChartColors: any[] = ['#3B6EFF']
  repriceActivitylabels: any[];
  _currentDateFilter: DatePickerModel;
  buyBoxWinningLoading: boolean;
  salesDataLoading: boolean;
  competitionDataLoading: boolean;
  repriceActivityLoading: boolean;
  defaultFilterButtonText: string = 'Last 30 Days'
  dateFilterButtonText: any = {};
  defaultDateFilter: DatePickerModel = {
    from: new Date(new Date().setDate(new Date().getDate() - 30)),
    to: new Date(),
    label: AvalableDateLabels.Last30Days,
  };
  dateFilter: any = {};
  get currentDateFilter(): DatePickerModel {
    return this._currentDateFilter;
  }
  @Input() set currentDateFilter(date: DatePickerModel) {    
    if (date) {
      this._currentDateFilter = date;
      this.setDateFilter(date);
    }
  }
  spin;
  dialogReference;
  constructor(@Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<BuyBoxGraphDetailsComponent>,
    private snackBar: MatSnackBar,
    private priceyardService: PriceyardService,
    private dialog: MatDialog,
    private datePipe: DatePipe) {}

  ngOnInit(): void {
    const today = new Date();
    this.currentDateFilter={
      to: today,
      from:new Date(today.getTime() - this.getDaysAgo(30)),
      label:'Last 30 Days'
    }
  }

  getWinninyBuyBox(res){
    let payload: any ={
      endDate: res ?  new Date(res.to) : new Date(),
      startDate:  res ?  new Date(res.from) : new Date(new Date().getTime() - this.getDaysAgo(30)),
      accountSkuId: this.data?.accountSkuId
    }
    this.buyBoxWinningLoading= true;
    this.priceyardService.BlackBoxWinningPricingListSummary(payload).subscribe((res:any)=>{
      this.spin = false;
      this.dialogReference?.close();
      this.buyBoxWinninglabels = res.map((res) => res.label)
      this.buyBoxWinningData = [{
        showInLegend: false,  
        data:  res?.map((res) => res.data)
      }]
      this.buyBoxWinningLoading= false;
     },(error)=>{
      this.buyBoxWinningLoading= false;
      this.spin = false;
      this.dialogReference?.close();
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
    })
  }

  getSales(res){
    let payload: any ={
      endDate: res ?  new Date(res.to) : new Date(),
      startDate:  res ?  new Date(res.from) : new Date(new Date().getTime() - this.getDaysAgo(30)),
      accountSkuId: this.data?.accountSkuId
    }
    this.salesDataLoading = true;
    this.priceyardService.SalesPricingListSummary(payload).subscribe((res:any)=>{
      this.saleslabels = res.map((res) => res.label)
      this.salesData = [{
        showInLegend: false,  
        data:  res?.map((res) => res.data)
      }]
      this.salesDataLoading = false;
      this.spin = false;
      this.dialogReference?.close();
     },(error)=>{
      this.salesDataLoading = false;
      this.spin = false;
      this.dialogReference?.close();
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
    })
  }

  getCompetition(res){
    let payload: any ={
      endDate: res ?  new Date(res.to) : new Date(),
      startDate:  res ?  new Date(res.from) : new Date(new Date().getTime() - this.getDaysAgo(30)),
      accountSkuId: this.data?.accountSkuId
    }
    this.competitionDataLoading = true;
    this.priceyardService.CompetitionPricingListSummary(payload).subscribe((res:any)=>{
      this.spin = false;
      this.dialogReference?.close();
      this.competitionlabels =  res.map((res) => res.label);
      this.competitionData = [{
        showInLegend: false,  
        data:   res?.map((res) => res.data)
      }]
      this.competitionDataLoading = false;
     },(error)=>{
      this.competitionDataLoading = false;
      this.spin = false;
      this.dialogReference?.close();
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
    })
  }

  getRepriceActtivity(res){
    let payload: any ={
      endDate: res ?  new Date(res.to) : new Date(),
      startDate:  res ?  new Date(res.from) : new Date(new Date().getTime() - this.getDaysAgo(30)),
      accountSkuId: this.data?.accountSkuId
    }
    this.repriceActivityLoading = true;
    this.priceyardService.RepriceActivityPricingListSummary(payload).subscribe((res:any)=>{
      this.spin = false;
      this.dialogReference?.close();
      this.repriceActivitylabels = res.map((res) => res.label);
      this.repriceActivityData = [{
        showInLegend: false,  
        data:  res?.map((res) => res.data)
      }]
      this.repriceActivityLoading = false;
     },(error)=>{
      this.repriceActivityLoading = false;
      this.spin = false;
      this.dialogReference?.close();
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: error?.error?.error[0],
              action: 'Dismiss',
              type: 'error',
            },
          }
        );
    })
  }

  tabClicked(e) {
    this.activeTab = e; 
    this.setDateFilter((this.dateFilter && this.dateFilter[this.activeTab.toLowerCase().replace(/\s/g, "")]) || this.defaultDateFilter);
  }

  getDaysAgo(amountOfDays: number): number {
    return amountOfDays * 24 * 60 * 60 * 1000;
  }

  openDateDialog = (e: MouseEvent) => {    
    this.dialog
      .open(DatePickerDialogComponent, {
        width: "450px",
        position: this.getDialogPosition(e),
        data: {data: this.dateFilter && this.dateFilter[this.activeTab.toLocaleLowerCase().replace(/\s/g, "")] || this.currentDateFilter,
        callBackFn: (dialogRef, data,spin) => {
          this.dialogReference = dialogRef;
          this.spin = spin;
          this.currentDateFilter=data;            
        }},
      })
      .afterClosed()
      .subscribe();
  };

  getDialogPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      left: targetPosision.right - 155 + "px",
      top: targetPosision.top - 100 + "px",
    };
  }

  setDateFilter(date){
    const dateString = `${this.datePipe.transform(this.currentDateFilter.from,"M/d/yy")} - ${this.datePipe.transform(this.currentDateFilter.to, "M/d/yy")}`;
    const displayDate = date.label && date.label !== "custom" ? date.label : dateString;
    if(this.activeTab === 'BuyBox Winning'){
      this.getWinninyBuyBox(date);
      this.dateFilterButtonText['buyboxwinning'] = displayDate;
      this.dateFilter['buyboxwinning'] = date;
    } else if(this.activeTab === 'Sales'){
      this.getSales(date);
      this.dateFilterButtonText['sales'] = displayDate;
      this.dateFilter['sales'] = date;
    } else if(this.activeTab === 'Competition'){
      this.getCompetition(date);
      this.dateFilterButtonText['competition'] = displayDate;
      this.dateFilter['competition'] = date;
    } else if(this.activeTab === 'Reprice Activity'){
      this.getRepriceActtivity(date);
      this.dateFilterButtonText['repriceactivity'] = displayDate;
      this.dateFilter['repriceactivity'] = date;
    } 
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}